import {
  useUpdatePreferenceTag,
  useGetPreferenceTag,
  getPreferenceTagsKey,
  getPreferenceTagKey,
} from 'api-hooks/preference-tag';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import { queryClient } from 'common/repositories/query-client';
import LoadingComponent from 'components/common/loading';
import notification from 'components/common/notification';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import { DetailContainer, SeparatorVertical } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import * as React from 'react';
import { NavigationProps } from 'types';

import PreferenceTagForm from './components/form';

export type PreferenceTagViewParams = {
  id: string;
};

export default function PreferenceTagView(
  props: NavigationProps<NavigationRoutes.PreferenceTagsView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } = useGetPreferenceTag({
    id,
  });
  const { mutateAsync, error: errorMutate } = useUpdatePreferenceTag();

  const preferenceTag = data?.data;

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          {!!errorMutate && !!errorMutate.message && (
            <>
              <Notification
                overrides={{
                  Body: { style: { width: 'auto', wordBreak: 'break-all' } },
                }}
                kind={KIND.negative}
                closeable
              >
                {() => errorMutate.message}
              </Notification>
              <SeparatorVertical $margin={8} />
            </>
          )}
          <PreferenceTagForm
            {...props}
            preferenceTag={preferenceTag}
            onSubmit={async (input, form) => {
              const result = await mutateAsync({
                body: input,
                preferenceTagId: preferenceTag!.id,
              });

              queryClient.refetchQueries([getPreferenceTagsKey()[0]]);
              queryClient.refetchQueries(
                getPreferenceTagKey({ id: result.data.id }),
              );

              notification.success({ message: result?.message });

              return result.data;
            }}
          />
        </>
      }
    />
  );
}
